import request from '@/utils/request';

export default {
    getConfigTypes: async({ dispatch, commit }) => {
        await request({ method: 'get', url: '/admin/settings/types' })
            .then(res => {
                if (res.data) {
                    commit('SET_ADMIN_TYPES', res.data.admin || []);
                    commit('SET_BOSS_TYPES', res.data.boss || []);
                }
            }).catch(error => {
                if(error.response && error.response.data && error.response.data.error) {
                    dispatch('alert/addMessage', {
                        message: error.response.data.error
                    }, { root: true });
                }
            });
    },

    getSettings: async({ dispatch, commit }, data) => {
        const { role, params } = data;

        const urls = {
            admin: '/admin/settings',
            boss: '/admin/settings/brand'
        };

        commit('SET_ITEMS', []);

        await request({ method: 'get', url: urls[role], params })
            .then(res => {
                if (res.data) {
                    commit('SET_ITEMS', res.data);
                }
            }).catch(error => {
                if(error.response && error.response.data && error.response.data.error) {
                    dispatch('alert/addMessage', {
                        message: error.response.data.error
                    }, { root: true });
                }
            });
    },

    edit: async({ dispatch }, data) => {
        if (!data.id) {
            dispatch('alert/addMessage', {
                message: 'unknown'
            }, { root: true });

            return;
        }

        return await request({ method: 'put', url: `/admin/settings/${data.id}`, data })
            .then(res => {
                dispatch('alert/addMessage', {
                    type: 'success',
                    message: 'success'
                }, { root: true });

                return res.data && res.data.id;
            }).catch(error => {
                if(error.response && error.response.data && error.response.data.error) {
                    dispatch('alert/addMessage', {
                        message: error.response.data.error
                    }, { root: true });
                }
            });
    },

    useDefaultSettingsForBrand: async({ dispatch }, params) => {
        await request({ method: 'delete', url: '/admin/settings/brand', params })
            .then(res => {
                if (res.data) {
                    dispatch('alert/addMessage', {
                        type: 'success',
                        message: 'success'
                    }, { root: true });
                }
            }).catch(error => {
                if(error.response && error.response.data && error.response.data.error) {
                    dispatch('alert/addMessage', {
                        message: error.response.data.error
                    }, { root: true });
                }
            });
    },

    changeDefault: async({ dispatch }, data) => {
        await request({ method: 'post', url: '/admin/settings/brand', data })
            .then(res => {
                if (res.data) {
                    dispatch('alert/addMessage', {
                        type: 'success',
                        message: 'success'
                    }, { root: true });
                }
            }).catch(error => {
                if(error.response && error.response.data && error.response.data.error) {
                    dispatch('alert/addMessage', {
                        message: error.response.data.error
                    }, { root: true });
                }
            });
    }
};
